export const labels = {
  // Basefunktions
  selectBaseFunction: 'Choose a Basefunction',
  zero: 'Zero',
  sin: 'Sinus',
  cos: 'Cosinus',
  kamm: 'Comb',
  ones: 'Constant',
  pyra: 'Pyramid',
  single: 'Single',
  custom: 'Custom',

  // Filters
  chooseArraySize: 'Choose the size:',
  reset: 'Reset all Functions',
  centeredZeroCheckbox: 'Origin centered',
  drawLine: 'Draw Line',
  scale: 'Scale all Functions',

  // Gridlabels
  realspatial: 'Spatial Real',
  realspectral: 'Spectral Real',
  imagspatial: 'Spatial Imaginary',
  imagspectral: 'Spectral Imaginary',

  // Pages
  home: 'Home',
  fourier: 'Fourier-Transformation',
  about: 'About',
  legal: 'Legal Notice',

  // Links
  uni: 'https://uni-tuebingen.de/',
  github: 'https://github.com/MaximilianPfitzenmaier/Fourier-Transformation',
  nayuki: 'https://www.nayuki.io/page/free-small-fft-in-multiple-languages/',
};
